// extracted by mini-css-extract-plugin
export var closeButton = "_1w-3";
export var header = "_1w-0";
export var link = "_1w-1";
export var retryButton = "_1w-2";